var React = require('react');

function BookOpen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M48 28C48 23.7565 46.3143 19.6869 43.3137 16.6863C40.3131 13.6857 36.2435 12 32 12H8V72H36C39.1826 72 42.2348 73.2643 44.4853 75.5147C46.7357 77.7652 48 80.8174 48 84M48 28V84M48 28C48 23.7565 49.6857 19.6869 52.6863 16.6863C55.6869 13.6857 59.7565 12 64 12H88V72H60C56.8174 72 53.7652 73.2643 51.5147 75.5147C49.2643 77.7652 48 80.8174 48 84","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

BookOpen.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = BookOpen;

BookOpen.default = BookOpen;
